<main id="simple-layout">
    <div class="container box-shadow-right">
        <router-outlet></router-outlet>
    </div>
</main>
